import { gql } from '@/apollo';

export const SETUP_AVAILABILITY = gql`
  query SetupAvailability {
    setupAvailability {
      available
      requiresSecret
    }
  }
`;

export const SETUP_DATABASE = gql`
  mutation SetupDatabase($setupSecret: String) {
    setupDatabase(setupSecret: $setupSecret) {
      success
      message
      accountsCreated
    }
  }
`;

export const GET_ENVIRONMENT_STATUS = gql`
  query GetEnvironmentStatus($setupSecret: String) {
    getEnvironmentStatus(setupSecret: $setupSecret) {
      database {
        configured
        status
        message
      }
      jwt {
        configured
        status
        message
      }
      cors {
        configured
        status
        message
      }
      entra {
        enabled
        configured
        status
        message
      }
      nodeEnv
      port
      databaseConnection {
        server
        database
        user
        status
        message
      }
    }
  }
`;
